import {
  FetchCacheItemsSources,
  FetchCacheItemsTrackTotalHits
} from '../../../../types';
import {
  FetchNewFinStatusReasonTagsCacheKey,
  FetchNewFinStatusReasonTagsFilters,
  FetchNewFinStatusReasonTagsGqlQuery,
  FetchNewFinStatusReasonTagsLimit,
  FetchNewFinStatusReasonTagsPage,
  FetchNewFinStatusReasonTagsSort
} from '../../newFinStatusReasonTagsTypes';

import { useCacheIndexQuery } from '../../../common/reactQuery/hooks/useCacheIndexQuery';

import {
  INITIAL_NEW_FIN_STATUS_REASON_TAGS_FILTERS,
  INITIAL_NEW_FIN_STATUS_REASON_TAGS_LIMIT,
  INITIAL_NEW_FIN_STATUS_REASON_TAGS_PAGE,
  INITIAL_NEW_FIN_STATUS_REASON_TAGS_SORT
} from '../../newFinStatusReasonTagsConstants';

interface PaginatedNewFinStatusReasonTagsOptions {
  action?: string;
  cacheKey: FetchNewFinStatusReasonTagsCacheKey;
  initialFilters?: FetchNewFinStatusReasonTagsFilters;
  initialSort?: FetchNewFinStatusReasonTagsSort;
  initialPage?: FetchNewFinStatusReasonTagsPage;
  initialLimit?: FetchNewFinStatusReasonTagsLimit;
  source?: FetchCacheItemsSources;
  trackTotalHits?: FetchCacheItemsTrackTotalHits;
  options?: {
    enabled?: boolean;
    enabledPlaceholder?: boolean;
    withoutPrefetch?: boolean;
  };
  query: FetchNewFinStatusReasonTagsGqlQuery;
}

const scope = 'newFinStatusReasonTags';

function useFinPaginatedNewFinStatusReasonTags<
  FetchNewFinStatusReasonTagsInvoiceType
>({
  action,
  cacheKey,
  initialFilters = INITIAL_NEW_FIN_STATUS_REASON_TAGS_FILTERS,
  initialSort = INITIAL_NEW_FIN_STATUS_REASON_TAGS_SORT,
  initialPage = INITIAL_NEW_FIN_STATUS_REASON_TAGS_PAGE,
  initialLimit = INITIAL_NEW_FIN_STATUS_REASON_TAGS_LIMIT,
  options,
  query,
  source = FetchCacheItemsSources.DB,
  trackTotalHits
}: PaginatedNewFinStatusReasonTagsOptions) {
  const {
    changeItemsFilters,
    clearItemsFilters,
    currentFilters,
    currentLimit,
    currentPage,
    currentSort,
    data,
    filterItems,
    isFetched,
    isLoading,
    isPlaceholderData,
    items,
    itemsError,
    itemsErrorMessage,
    itemsTotalCount,
    limitItems,
    meta,
    paginateItems,
    prefetchItems,
    sortItems,
    updateItemCache
  } = useCacheIndexQuery<FetchNewFinStatusReasonTagsInvoiceType>({
    action,
    cacheKey,
    cacheQuery: query,
    defaultApi: 'cache_api',
    initialFilters,
    initialLimit,
    initialPage,
    initialSort,
    scope,
    query,
    options,
    source,
    trackTotalHits
  });

  return {
    changeNewFinStatusReasonTagsFilters: changeItemsFilters,
    clearNewFinStatusReasonTagsFilters: clearItemsFilters,
    filterNewFinStatusReasonTags: filterItems,
    newFinStatusReasonTags: items,
    newFinStatusReasonTagsData: data,
    newFinStatusReasonTagsError: itemsError,
    newFinStatusReasonTagsErrorMessage: itemsErrorMessage,
    newFinStatusReasonTagsFetched: isFetched,
    newFinStatusReasonTagsFilters: currentFilters,
    newFinStatusReasonTagsIsPlaceholderData: isPlaceholderData,
    newFinStatusReasonTagsLimit: currentLimit,
    newFinStatusReasonTagsLoading: isLoading,
    newFinStatusReasonTagsMeta: meta,
    newFinStatusReasonTagsPage: currentPage,
    newFinStatusReasonTagsSort: currentSort,
    newFinStatusReasonTagsTotalCount: itemsTotalCount,
    limitNewFinStatusReasonTags: limitItems,
    paginateNewFinStatusReasonTags: paginateItems,
    prefetchNewFinStatusReasonTags: prefetchItems,
    sortNewFinStatusReasonTags: sortItems,
    updateInvoiceCache: updateItemCache
  };
}

export default useFinPaginatedNewFinStatusReasonTags;
